import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[carouselSlide]',
    standalone: true
})
export class CarouselSlideDirective {
    template = inject(TemplateRef<any>);

    slideData = {
      isActive: false,
      isPrev: false,
      isNext: false,
      isVisible: false,
      isDuplicate: false,
    };

    slideIndex?: number;

    get classNames(): string | undefined {
        return this._classNames;
    }

    set classNames(value: string) {
        if (this._classNames === value) {
            return;
        }

        this._classNames = value;

        this.slideData = {
            isActive: this.hasClass(['swiper-slide-active', 'swiper-slide-duplicate-active']),
            isVisible: this.hasClass(['swiper-slide-visible']),
            isDuplicate: this.hasClass(['swiper-slide-duplicate']),
            isPrev: this.hasClass(['swiper-slide-prev', 'swiper-slide-duplicate-prev']),
            isNext: this.hasClass(['swiper-slide-next', 'swiper-slide-duplicate-next'])
        };
    }

    private _classNames?: string;

    protected hasClass(classNames: string[]) {
        if (!this._classNames) {
            return false;
        }

        return classNames.some(className => this._classNames!.indexOf(className) >= 0);
    }
}
